module.exports = {
  blogPostDir: "articles", // The name of directory that contains your posts.
  projectsPostDir: "projects",
  siteTitle: "Mohamed Azazy - محمد عزازي", // Site title.
  siteTitleAlt: "UI/UX Designer", // Alternative site title for SEO.
  siteLogo: "/static/logos/logo.png", // Logo used for SEO and manifest.
  siteUrl: "https://azazy.net", // Domain of your website without pathPrefix.
  pathPrefix: "/", // Prefixes all links. For cases when deployed to example.github.io/gatsby-material-starter/.
  projectPathPrefix: "/projects/",
  siteDescription:
    "Mohamed Azazy is a senior UI/UX designer from Egypt, worked with indeviduals, startups and enterprises to create awesome websites and mobile apps.", // Website description used for RSS feeds/meta description tag.
  siteRss: "/rss.xml", // Path to the RSS file.
  //siteFBAppID: "1825356251115265", // FB Application ID for using app insights
  siteGATrackingID: "UA-27680723-1", // Tracking code ID for google analytics.
  //disqusShortname: "https-vagr9k-github-io-gatsby-material-starter", // Disqus shortname.
  postDefaultCategoryID: "Tech", // Default category for posts.
  userName: "Mohamed Azazy", // Username to display in the author segment.
  userTwitter: "https://twitter.com/nileninja", // Optionally renders "Follow Me" in the UserInfo segment.
  userLocation: "Cairo, Egypt", // User location to display in the author segment.
  userAvatar: "https://api.adorable.io/avatars/150/test.png", // User avatar to display in the author segment.
  userDescription:
    "Yeah, I like animals better than people sometimes... Especially dogs. Dogs are the best. Every time you come home, they act like they haven't seen you in a year. And the good thing about dogs... is they got different dogs for different people.", // User description to display in the author segment.
  // You can translate these three words into your language if you want. They'll be shown on the project page header
  client: 'العميل',
  date: 'التاريخ',
  service: 'الخدمة',
  // Links to social profiles/projects you want to display in the author segment/navigation bar.
  mainLinks: [
    {
      label: "الرئيسية",
      url: "/"
    },
    {
      label: "المقالات",
      url: "/articles"
    },
    {
      label: "المشاريع",
      url: "/projects"
    }
  ],
  userLinks: [
    {
      label: "Dribbble",
      url: "https://dribbble.com/azazy",
      iconClassName: "fa fa-dribbble"
    },
    {
      label: "Twitter",
      url: "https://twitter.com/NileNinja",
      iconClassName: "fa fa-twitter"
    },
    {
      label: "LinkedIn",
      url: "https://www.linkedin.com/in/mohamedazazy/",
      iconClassName: "fa fa-linkedin"
    },
    {
      label: "CodePen",
      url: "https://codepen.io/azazy",
      iconClassName: "fa fa-codepen"
    },
    {
      label: "GitHub",
      url: "https://github.com/NileNinja",
      iconClassName: "fa fa-github"
    },
    {
      label: "Email",
      url: "mailto:mohamed@azazy.net",
      iconClassName: "fa fa-envelope"
    }
  ],
  copyright: "Copyright © 2017. Mohamed Azazy" // Copyright string for the footer of the website and RSS feed.
};



// WEBPACK FOOTER //
// ./data/SiteConfig.js